import promptDescription from '../templates/prompt.description.tpl.html';

const INTERNAL_OPTIONS = {
    // Amount of time inline iframe is allowed to load. Will show error if exceeded.
    iframeTimeout: 45000, // 45 seconds
    // Internal base URL. Always `https://verify.<HOST>.com` with no leading slash. Defined in build.
    endpoint: '{%AGEGO_ENDPOINT%}',
    frontend: '{%AGEGO_FRONTEND%}'
}

const AGEGO_ENDPOINT = '{%AGEGO_ENDPOINT%}';

const DEFAULT_OPTIONS = {
    siteId: undefined, // must be defined
    returnTo: undefined, // undefined for automatic
    userNonce: undefined, // use this value for nonce, instead of generating random.
    callbackToken: undefined, // use this value as callback token that is replaced in the site callback url.
    autoBlur: true,
    verifyMode: 'inline', // 'inline', 'redirect', or 'auto-redirect'
    requireAgeVerification: true,
    allowDirectContinue: false,
    underageRedirectTo: 'https://google.com',
    overlay: {
        logo: '#', // logo URL
        theme: 'auto', // 'dark', 'light' or 'auto'
        style: undefined,
        content: {
            heading: 'Website for adults viewing only!',
            description: promptDescription,
            ctaAgeVerify: {
                cta: 'Verify age',
                label: 'Continue with age verification'
            },
            ctaDirectContinue: {
                cta: 'Enter',
                label: 'I am 18 years or older'
            },
            ctaUnderageSkip: {
                cta: 'I am not 18 years old'
            }
        },
        messages: {
            errors: {
                'nonceInvalid': 'Internal error. Please, try again.',
                'agegoError': 'Age verification failed. Please, try again later.',
                'notVerified': 'Your age could not be verified. Please, try again.',
                'expired': 'Your age verification has expired. Please, try again.',
                'internalError': 'Failed to start age verification process - internal error. Please, try again.',
            }
        }
    },
    cookies: {
        directContinueState: {
            name: 'agego_dcnt',
            expires: 'session', // 'year', 'month', 'week', 'session' or a number number of days as int.
            attr: {
                sameSite: 'strict',
                path: '/',
                secure: false,
            }
        },
        ageVerifyState: {
            name: 'agego_aver',
            expires: 'session',
            attr: {
                sameSite: 'strict',
                path: '/',
                secure: false,
            }
        },
        ageVerifyNonce: {
            name: 'agego_dnonce',
            expires: 'session',
            attr: {
                sameSite: 'strict',
                path: '/',
                secure: false,
            }
        }
    },
    events: {
        // Called when age verification flow is completed. Can be used for backend verification.
        // eslint-disable-next-line no-unused-vars
        onVerificationFlowEnd(eventData) {
        },
        // Called when age verification flow failed for any reason.
        // eslint-disable-next-line no-unused-vars
        onVerificationFlowFailed(error) {
        },
        // Called when user executes age verification CTA.
        onAgeVerify() {
        },
        // Called when user executes direct continue CTA.
        onDirectContinue() {
        },
        // Called when user executes underage CTA.
        onUnderageSkip() {
        },
        // Called for returning users, when age was already verified.
        onVerifiedBefore() {
        },
    }
}

export {DEFAULT_OPTIONS, INTERNAL_OPTIONS, AGEGO_ENDPOINT};
